// js/render/Palette.js
// 索引式像素調色盤。索引 0 = 透明；精靈以索引參照顏色。
// 限定 ~21 色，讓像素風視覺協調。

export const PALETTE = [
  null,           // 0  透明
  '#0d1b2a',      // 1  深色輪廓 / 墨
  '#1b263b',      // 2  極深
  '#23252d',      // 3  暗路面
  '#343741',      // 4  柏油路
  '#41454f',      // 5  路面格線
  '#4a4e59',      // 6  路面紋理
  '#f4d35e',      // 7  人潮箭頭（黃）
  '#6b4226',      // 8  木深 — 公事包 / 咖啡
  '#8b5a2b',      // 9  泥土 — 工地
  '#c89b6b',      // 10 沙 — 工地內層
  '#6a994e',      // 11 草綠 — 病菌身體
  '#386641',      // 12 草深 — 病菌輪廓
  '#bc4749',      // 13 紅 — 路障 / 危險
  '#e07a5f',      // 14 橘 — 足跡 / 邊飾
  '#f2e8cf',      // 15 米 — 甲板 / 紙
  '#f4a261',      // 16 帆 / 暖
  '#e9c46a',      // 17 黃 — 收集物光
  '#2a9d8f',      // 18 青
  '#ffffff',      // 19 白亮
  '#000000',      // 20 黑
];

// 將單一字元轉成調色盤索引（'0'-'9' = 0-9；'a'-'k' = 10-20；'.'/' ' = 透明）
export function charToIndex(ch) {
  if (ch === '.' || ch === ' ') return 0;
  const c = ch.charCodeAt(0);
  if (c >= 48 && c <= 57) return c - 48;
  if (c >= 97 && c <= 122) return c - 97 + 10;
  return 0;
}
